import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const ClientAndShopSection = ({ title, children, sx }) => {
    return (
        <Box
            display="flex"
            alignItems="center"
            direction="row"
          top={0}
            spacing={1}
           marginRight={5}
            width={400}
            sx={{ ...sx }}
        >
            <Typography sx={{ textAlign: "left", width: 80 }} fontSize={15} >
                {title}
            </Typography>
            {children}
        </Box>
    );
};

export default ClientAndShopSection;
